import apolloClient from 'store/apolloClient';
import * as services from 'modules/appointmentsManagement/services/fetchContracts';
import { MESSAGING } from 'modules/common/constants/consultationTypes';
import { checkExternalInitialization } from 'shared/utils/externalLoginUtils';
import apiCall from 'shared/utils/apiCall';
import createAsyncAction from 'shared/utils/createAsyncAction';
import errorAction from 'shared/utils/errorAction';
import createAction from './index';

export const FETCH_APPOINTMENT_CONTRACTS = createAsyncAction(createAction('FETCH_APPOINTMENT_CONTRACTS'));

export const fetchAppointmentContracts = () => dispatch => {
  dispatch({
    type: FETCH_APPOINTMENT_CONTRACTS.pending,
  });

  const apiCallParams = {
    query: services.FETCH_CONTRACTS,
    fetchPolicy: 'no-cache',
  };

  return apiCall(apolloClient.query, apiCallParams)
    .then((response) => {
      const contracts = response.data.contracts;
      const isMobile = checkExternalInitialization();

      return dispatch({
        type: FETCH_APPOINTMENT_CONTRACTS.success,
        payload: contracts.edges
          .map(item => item.contract)
          .filter(item => isMobile ? true : !(item.service.consultationTypes.length === 1 && item.service.consultationTypes.includes(MESSAGING))),
      });

    })
    .catch((err) => {
      dispatch(errorAction(FETCH_APPOINTMENT_CONTRACTS.failure, err));

      throw err;
    });
};
